import { useState, useEffect } from "react";
import { default as toWebVTT } from "srt-webvtt";
import Box from "@mui/material/Box";
import { Button, Divider } from "@mui/material";
import { getSubtitlesApi } from "../../../services/subtitlesApi";
import Typography from "@mui/material/Typography";
import ButtonGroup from '@mui/material/ButtonGroup';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import IconButton from '@mui/material/IconButton';
import Slecetor from "./PopoverColorPicker/Slecetor"
import srtParser2 from "srt-parser-2";
import RttIcon from '@mui/icons-material/Rtt';
import { customToastify } from "../../pages/utils/utilsFunctions"
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import SyncIcon from '@mui/icons-material/Sync';

export default function CompareSubsBox(props) {
    const { handlesAllSubtitlesList, allSubtitlesList, compareSubsBox, handleSubtitlesTimeShift, subtitlesTimeShift, videoRef } = props
    const [allSubtitlesLength, setAllSubtitlesLength] = useState(0)
    const [timeShiftBtn, setTimeShiftBtn] = useState(false)
    const [color, setColor] = useState({ color: "#ffffff", bgColor: "#000000bf" })
    const [subContent3, setSubContent3] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent4, setSubContent4] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent5, setSubContent5] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent6, setSubContent6] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent7, setSubContent7] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent8, setSubContent8] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent9, setSubContent9] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent10, setSubContent10] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent11, setSubContent11] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent12, setSubContent12] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent13, setSubContent13] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent14, setSubContent14] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent15, setSubContent15] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent16, setSubContent16] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent17, setSubContent17] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent18, setSubContent18] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent19, setSubContent19] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent20, setSubContent20] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent21, setSubContent21] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent22, setSubContent22] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent23, setSubContent23] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent24, setSubContent24] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent25, setSubContent25] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent26, setSubContent26] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent27, setSubContent27] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent28, setSubContent28] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent29, setSubContent29] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent30, setSubContent30] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent31, setSubContent31] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent32, setSubContent32] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent33, setSubContent33] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent34, setSubContent34] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent35, setSubContent35] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent36, setSubContent36] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent37, setSubContent37] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent38, setSubContent38] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent39, setSubContent39] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent40, setSubContent40] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent41, setSubContent41] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })
    const [subContent42, setSubContent42] = useState({ endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" })

    const initialSubContent = (indexes) => {
        for (const index in indexes) {
            addSubContent(indexes[index], { endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "در حال بارگزاری" })
        }
    }

    const getSubContent = (subNumber) => {
        switch (subNumber) {
            case 3:
                return subContent3
            case 4:
                return subContent4
            case 5:
                return subContent5
            case 6:
                return subContent6
            case 7:
                return subContent7
            case 8:
                return subContent8
            case 9:
                return subContent9
            case 10:
                return subContent10
            case 11:
                return subContent11
            case 12:
                return subContent12
            case 13:
                return subContent13
            case 14:
                return subContent14
            case 15:
                return subContent15
            case 16:
                return subContent16
            case 17:
                return subContent17
            case 18:
                return subContent18
            case 19:
                return subContent19
            case 20:
                return subContent20
            case 21:
                return subContent21
            case 22:
                return subContent22
            case 23:
                return subContent23
            case 24:
                return subContent24
            case 25:
                return subContent25
            case 26:
                return subContent26
            case 27:
                return subContent27
            case 28:
                return subContent28
            case 29:
                return subContent29
            case 30:
                return subContent30
            case 31:
                return subContent31
            case 32:
                return subContent32
            case 33:
                return subContent33
            case 34:
                return subContent34
            case 35:
                return subContent35
            case 36:
                return subContent36
            case 37:
                return subContent37
            case 38:
                return subContent38
            case 39:
                return subContent39
            case 40:
                return subContent40
            case 41:
                return subContent41
            case 42:
                return subContent42
            default:
                return { endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "مشکل در بارگزاری" }
        }

    }
    const addSubContent = (subNumber, content) => {
        switch (subNumber) {
            case 3:
                setSubContent3(content)
                break;
            case 4:
                setSubContent4(content)
                break;
            case 5:
                setSubContent5(content)
                break;
            case 6:
                setSubContent6(content)
                break;
            case 7:
                setSubContent7(content)
                break;
            case 8:
                setSubContent8(content)
                break;
            case 9:
                setSubContent9(content)
                break;
            case 10:
                setSubContent10(content)
                break;
            case 11:
                setSubContent11(content)
                break;
            case 12:
                setSubContent12(content)
                break;
            case 13:
                setSubContent13(content)
                break;
            case 14:
                setSubContent14(content)
                break;
            case 15:
                setSubContent15(content)
                break;
            case 16:
                setSubContent16(content)
                break;
            case 17:
                setSubContent17(content)
                break;
            case 18:
                setSubContent18(content)
                break;
            case 19:
                setSubContent19(content)
                break;
            case 20:
                setSubContent20(content)
                break;
            case 21:
                setSubContent21(content)
                break;
            case 22:
                setSubContent22(content)
                break;
            case 23:
                setSubContent23(content)
                break;
            case 24:
                setSubContent24(content)
                break;
            case 25:
                setSubContent25(content)
                break;
            case 26:
                setSubContent26(content)
                break;
            case 27:
                setSubContent27(content)
                break;
            case 28:
                setSubContent28(content)
                break;
            case 29:
                setSubContent29(content)
                break;
            case 30:
                setSubContent30(content)
                break;
            case 31:
                setSubContent31(content)
                break;
            case 32:
                setSubContent32(content)
                break;
            case 33:
                setSubContent33(content)
                break;
            case 34:
                setSubContent34(content)
                break;
            case 35:
                setSubContent35(content)
                break;
            case 36:
                setSubContent36(content)
                break;
            case 37:
                setSubContent37(content)
                break;
            case 38:
                setSubContent38(content)
                break;
            case 39:
                setSubContent39(content)
                break;
            case 40:
                setSubContent40(content)
                break;
            case 41:
                setSubContent41(content)
                break;
            case 42:
                setSubContent42(content)
                break;
            default:
                console.log("addSubContent", subNumber, content)
        }
    }

    const addTracks = async (indexes, allSubtitlesList) => {
        try {
            for (const index in indexes) {
                await addTrackToVideo(allSubtitlesList[indexes[index] - 3]["type"], indexes[index], allSubtitlesList[indexes[index] - 3]["content"]);
            }
        } catch (error) {
            console.log("errr addTracks", error)
        }
    }

    const addTrackToVideo = async (typeOfsub, trackNumber, subInfo) => {
        try {
            let video = document.querySelector("#MainVideo video");
            let subFile
            if (typeOfsub == "id") {
                let response = await getSubtitlesApi({ subtitlesUploadId: subInfo })
                subFile = new File([response.data], subInfo);
            } else subFile = subInfo;
            const textTrackUrl = await toWebVTT(subFile);
            let oldTrack = document.getElementById(`compareSubtitlesTrack${trackNumber}`);
            if (oldTrack) video.removeChild(oldTrack);
            let newTrack = document.createElement("track");
            newTrack.kind = "subtitles";
            newTrack.id = `compareSubtitlesTrack${trackNumber}`;
            newTrack.src = textTrackUrl;
            video.appendChild(newTrack);
            srtToJson(subFile, trackNumber);
            if (video["textTracks"]) {
                for (let i = 0; i < video["textTracks"].length; i++) {
                    video.textTracks[i].mode = "hidden";
                }
            }
        } catch (error) {
            console.log("Error in addTrackToVideo", error);
        }
    };


    const srtToJson = async (file, number) => {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = () => {
            const text = reader.result;
            let parser = new srtParser2();
            let result = parser.fromSrt(text);
            subtitleContentControl(result, number);
        };
    };



    const subtitleContentControl = (subContent, number) => {

        addSubContent(number, { endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" });
        if (subContent.length == 0) return false;
        let seletedTrack = document.querySelector(`#compareSubtitlesTrack${number}`);
        seletedTrack.addEventListener("cuechange", function (e) {
            if (e.target.track.activeCues.length !== 0) {
                addSubContent(
                    number,
                    subContent[e.target.track.activeCues[0].id - 1]
                );
            } else {
                addSubContent(number, { endSeconds: false, endTime: false, id: 0, startSeconds: 300000, startTime: false, text: "" });
            }
        });
    };

    const sortSubtitlesList = (startTimeOne) => {
        if (videoRef["current"]["props"]["playing"]) {
            customToastify("error", "لطفا ایتدا فیلم را متوقف کنید");
        } else {
            let cp = [...allSubtitlesList]
            allSubtitlesList.forEach((sub, idx) => {
                cp[idx]["difference"] = Math.abs(startTimeOne - getSubContent(idx + 3)["startSeconds"])
            })
            let newSllSubtitlesList = cp.sort((a, b) => a.difference - b.difference);
            handlesAllSubtitlesList("sortSubtitles", 0, 0, newSllSubtitlesList)
            let indexes = [...Array(newSllSubtitlesList.length).keys()].map((i) => i + 3)
            initialSubContent(indexes)
            setAllSubtitlesLength(newSllSubtitlesList.length)
            addTracks(indexes, newSllSubtitlesList)
            let timeShiftValue = {}
            indexes.forEach((subNum, idx) => {
                timeShiftValue[`sub${subNum - 3}`] = 0
            })
            handleSubtitlesTimeShift(0, timeShiftValue, true)
        }
    }

    const syncSubtitles = (selectedSubIndex) => {
        let subOne
        allSubtitlesList.forEach((el, idx) => {
            if (el["subOne"] == true) {
                subOne = el
                subOne["index"] = idx
            }
        })
        if (videoRef["current"]["props"]["playing"]) {
            customToastify("error", "لطفا ایتدا فیلم را متوقف کنید");
        } else if (subOne) {
            if (getSubContent(subOne["index"] + 3)["startSeconds"] == 300000) {
                customToastify("error", "زیرنویس یک دیالوگ در حال پخش ندارد");
            } else if (getSubContent(selectedSubIndex + 3)["startSeconds"] == 300000) {
                customToastify("error", "زیرنویس کلیک شده دیالوگ در حال پخش ندارد");
            } else {
                const diffTime = (getSubContent(subOne["index"] + 3)["startSeconds"] * 10 - getSubContent(selectedSubIndex + 3)["startSeconds"] * 10) / 10
                handleSubtitlesTimeShift(selectedSubIndex, diffTime, false)
            }

        } else {
            customToastify("error", "لطفا ایتدا زیرنویس یک را انتخاب و همزمان سازی زیرنویس را فشار دهید");
        }
    }
    const handleChangeColor = (type, newColor) => {
        const cp = { ...color }
        if (type == "color") cp["color"] = newColor
        else if (type == "bgColor") cp["bgColor"] = newColor + "bf"
        setColor(cp)
    }

    useEffect(() => {
        if (allSubtitlesList.length > allSubtitlesLength) {
            let indexes = []
            for (let number = allSubtitlesLength; number < allSubtitlesList.length; number++) {
                indexes.push(parseInt(number) + 3)
            }
            initialSubContent(indexes)
            setAllSubtitlesLength(allSubtitlesList.length)
            addTracks(indexes, allSubtitlesList)
            let timeShiftValue = {}
            indexes.forEach((subNum, idx) => {
                timeShiftValue[`sub${subNum - 3}`] = 0
            })
            handleSubtitlesTimeShift(0, timeShiftValue, true)

        } else if (allSubtitlesList == 0) {
            setAllSubtitlesLength(0)
        }
    }, [allSubtitlesList])


    return (

        <Box id="CompareSubsBox" sx={{ display: compareSubsBox ? "block" : "none", position: "fixed", top: "10%", width: "86%", mx: "7%", zIndex: "999999", maxHeight: "70vh", border: "solid 1px", overflowY: "scroll", backgroundColor: color["bgColor"], color: color["color"], flexDirection: "column", justifyContent: "center" }}>
            <Divider sx={{ textAlign: "center" }}>
                مقایسه زیرنویس ها (مناسب برای صفحه نمایش های بزرگ)
            </Divider>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography>انتخاب زیرنویس</Typography>
                <ButtonGroup >
                    <Typography>متن:</Typography>
                    <Slecetor color={color["color"]} handleChangeColor={handleChangeColor} type={"color"} />
                    <Typography sx={{ ml: 0.5 }}>بک گراند:</Typography>
                    <Slecetor color={color["bgColor"]} handleChangeColor={handleChangeColor} type={"bgColor"} />
                    <Typography sx={{ ml: 0.5 }}>تنظیم زمان:</Typography>
                    <IconButton onClick={() => { setTimeShiftBtn(!timeShiftBtn) }} sx={{ alignSelf: "baseline" }} aria-label="تنظیم زمان زیرنویس" size="small" >
                        <RttIcon fontSize="inherit" color="info" />
                    </IconButton>
                </ButtonGroup>
                <Button size="small" variant="contained" onClick={() => { handlesAllSubtitlesList("closeCompareSubsBox") }}>انتخاب و برگشت</Button>
            </Box>
            <Divider color="red" />
            {allSubtitlesList.map((el, idx) => (<Box key={`subtitle-${idx + 3}`}>
                <Box id={`track${idx + 3}Content`} sx={{ display: el["show"] ? "flex" : "none", justifyContent: "space-between" }}>
                    <ButtonGroup >
                        <Button onClick={() => { handlesAllSubtitlesList("selectSub", idx, "subOne") }} variant={el["subOne"] ? "contained" : "outlined"}>یک</Button>
                        <Button onClick={() => { handlesAllSubtitlesList("selectSub", idx, "subTwo") }} variant={el["subTwo"] ? "contained" : "outlined"} >دو</Button>
                        {el["subOne"] ?
                            <Button sx={{ p: 0, m: 0 }} disabled={!el["subOne"]} onClick={() => { sortSubtitlesList(getSubContent(idx + 3)["startSeconds"]) }} endIcon={<SwapVertIcon />} variant="contained" ></Button>
                            : <Button sx={{ p: 0, m: 0 }} disabled={el["subOne"]} color="warning" onClick={() => { syncSubtitles(idx) }} endIcon={<SyncIcon />} variant="contained" ></Button>}
                    </ButtonGroup>
                    <Typography sx={{ mr: 5 }}>{getSubContent(idx + 3)["text"]} </Typography>
                    <ButtonGroup >
                        <IconButton onClick={() => { handlesAllSubtitlesList("hiddenSub", idx, "subTwo") }} aria-label="پنهان کردن زیرنویس" size="small" >
                            <DeleteOutlineIcon fontSize="inherit" color="error" />
                        </IconButton>
                        <Button sx={{ m: 0, p: 0, display: timeShiftBtn ? "block" : "none" }} onClick={() => { handleSubtitlesTimeShift(idx, 0.1, false) }} aria-label="پنهان کردن زیرنویس" >
                            0.1s+
                        </Button>
                        <Button sx={{ m: 0, p: 0, display: timeShiftBtn ? "block" : "none", cursor: "default" }} >
                            {subtitlesTimeShift[`sub${idx}`]}
                        </Button>
                        <Button sx={{ m: 0, p: 0, display: timeShiftBtn ? "block" : "none" }} onClick={() => { handleSubtitlesTimeShift(idx, -0.1, false) }} aria-label="پنهان کردن زیرنویس" >
                            0.1s-
                        </Button>
                    </ButtonGroup>
                </Box>
                <Divider color="#adbba6" sx={{ display: el["show"] ? "flex" : "none" }} />
            </Box>
            ))}
        </Box>

    );
}
